export const getPayrollProcessor = (state) => {
  return state.payrollProcessor;
};

export const getSelectedPayPeriodId = (state) => {
  const { selectedPayPeriodId } = getPayrollProcessor(state);
  return selectedPayPeriodId;
};
